import { choose } from '../../utils/platform';
import ShareFunctionsDesktop from './ShareFunctions.desktop';
import ShareFunctionsMobile from './ShareFunctions.mobile';

// Platform chooser: phone (APK or narrow browser) gets the full-screen sheet.
export default choose(ShareFunctionsDesktop, ShareFunctionsMobile);
